import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SplashService } from './splash.service';

// Boot splash. The element is always in the DOM after Angular bootstraps; a
// host class flips it to hidden, the CSS handles the fade. Mid-session
// "loading…" goes through AppSpinnerService, never through here.
@Component({
    selector: 'splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    host: { '[class.splash--hidden]': '!service.visible()' },
})
export class Splash {
    protected readonly service = inject(SplashService);
}
